<main id="main-content" tabindex="-1">
  <ng-container [ngTemplateOutlet]="routerOutlet"></ng-container>
</main>
<app-global-spinner *ngIf="$loading()"></app-global-spinner>
<app-footer></app-footer>
